import React from "react";
import Dropdown from "react-bootstrap/Dropdown";

const SimDropdownBasic = ({ labelIcon = null, data = null, onOptionClick = null, className = "" }) => {
  const optionClickHandler = (option) => {
    if (onOptionClick) {
      onOptionClick(option);
    }
  };
  return (
    <Dropdown className={className}>
      <Dropdown.Toggle>{labelIcon}</Dropdown.Toggle>
      <Dropdown.Menu>
        <div className="options">
          {data.map((option) => (
            <Dropdown.Item key={option?.key} onClick={() => optionClickHandler(option)}>
              <div className="option">
                {option?.icon && option?.icon}
                <span>{option?.label}</span>
              </div>
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SimDropdownBasic;
